/** @deprecated BetterStack logging is being replaced by Datadog logs; delete with BetterStackLoggerService. */
export const BETTERSTACK_API_KEY = 'BCnnZr6HPDAFC7xCnK4sqazk';

/** @deprecated BetterStack logging is being replaced by Datadog logs; delete with BetterStackLoggerService. */
export const BETTERSTACK_APP_URL = 'https://s1450038.us-east-9.betterstackdata.com';
